module.exports = __webpack_public_path__ + "static/blog-default-d6757f1bc0d9c919dad96e1ce4380091.jpg";